export const messagesAdmDataReport = {
    pt: {
        message:{
            date: "Data",
            generateReport: "Gerar relatório",
            start: "Começar"

        }
    },
    es: {
        message:{
            date:"Fecha",
            generateReport:"Generar informe",
            start:"Comenzar"
        }
    },
    en: {
        message:{
            date: "Date",
            generateReport: "Generate report",
            start: "Start"

        }
    }
}
